<!--导航默认按照白底布局
logo和logo-dark都绝对定位，logo在logo-dark上，通过控制logo的透明度过渡
1. 默认nav的theme为''
2. 在mounted生命周期和watch中，初始化theme和滚动参数：theme=''; scrollPercent = 0;
3. 处理滚动效果
-->
<template>
  <header
    class="
      common-header-component
      app-basic-min-width app-flex-row-space-between
    "
    :class="[theme, { sticky: scrollTop > 0 }]"
    :style="fixedStlye"
  >
    <div class="content">
      <div class="left app-flex-row">
        <div class="app-basic-layout-wrapper app-flex">
          <a href="/" class="logo-box">
            <img
              class="logo logo-dark"
              src="@/assets/img/logo-dark.png"
              title="微博营销"
              alt="微博营销"
              :style="{ opacity: isTransform ? `${scrollPercent / 100}` : 1 }"
            />
            <img
              v-if="$route.name === 'brand'"
              class="logo"
              src="@/assets/img/logo-golden.png"
              title="微博营销"
              alt="微博营销"
              :style="{
                opacity: isTransform ? `${1 - scrollPercent / 100}` : 0
              }"
            />
            <img
              v-else
              class="logo"
              src="@/assets/img/logo.png"
              title="微博营销"
              alt="微博营销"
              :style="{
                opacity: isTransform ? `${1 - scrollPercent / 100}` : 0
              }"
            />
          </a>

          <ul class="nav app-flex-row">
            <li
              v-for="(item, index) in navList"
              :key="index"
              class="font-14 item"
              :class="{ opened: item.opened }"
              @mouseenter="$set(item, 'opened', true)"
              @mouseleave="item.opened = false"
              @click="() => doStat(item)"
            >
              <a
                v-if="item.link && item.link.startsWith('http')"
                :href="item.link"
                target="_blank"
                :style="{ color: colorVal }"
              >
                {{ item.name }}
              </a>
              <router-link
                v-else-if="item.link"
                :class="{ active: item.active }"
                :to="item.link"
                :style="{ color: colorVal }"
              >
                {{ item.name }}
              </router-link>
              <a
                v-else
                :class="{ 'excat-nuxt-link-active': item.active }"
                href="javascript:void(0)"
              >
                {{ item.name }}
              </a>
              <div v-if="item.menu" class="menu-wrapper">
                <component :is="item.menu"></component>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="right app-flex-row" :style="{ color: colorVal }">
        <span class="app-flex-row font-14 label">
          <i class="iconfont icon-dianhua"></i>咨询热线
        </span>
        <strong class="iconfont icon-a-4000-970-970 tel"></strong>
      </div>
    </div>
  </header>
</template>
<script>
import * as throttle from 'lodash/throttle'
import MenuProducts from './MenuProducts'
import MenuInspiration from './MenuInspiration'
import MenuActivity from './MenuActivity'
// 导航动画过渡高度
const NAV_SCROLL_HEIGHT = 120
const FONT_COLOR_MIN = 114
const FONT_COLOR_MAX = 255
// 字体颜色变化范围 255-114
const FONT_COLOR_RANGE = FONT_COLOR_MAX - FONT_COLOR_MIN
// 页面滚动，header需要有过渡效果的页面
const transformNavPath = ['index', 'brand', 'topfans']

export default {
  components: {
    MenuActivity,
    MenuInspiration,
    MenuProducts
  },
  data() {
    return {
      // 过渡高度百分比，不带%符号
      scrollLeft: 0,
      scrollTop: 0,
      // 监听左右滚动，定位为fixed的顶部导航需要改变left值
      scrollPositionListener: null,
      // 监听上线滚动，nav主题色变化
      navThemeListener: null,
      navList: [
        { name: '首页', link: '/', module: 'top_nav_index' },
        {
          name: '营销产品',
          menu: MenuProducts
        },
        {
          name: '灵感启发',
          menu: MenuInspiration
        },
        {
          name: '活动与合作',
          menu: MenuActivity
        }
      ],
      theme: '',
      scrollPercent: 0,
      fontColorVal: FONT_COLOR_MAX
    }
  },
  computed: {
    isTransform() {
      return this.theme !== 'white'
    },
    fixedStlye() {
      return {
        left: `-${this.scrollLeft}px`,
        backgroundColor: this.isTransform
          ? `rgba(255, 255, 255, ${this.scrollPercent}%)`
          : `rgb(255, 255, 255)`
      }
    },
    colorVal() {
      if (this.$route.name === 'brand') {
        return ''
      }
      return `rgb(${this.fontColorVal},${this.fontColorVal},${this.fontColorVal})`
    }
  },

  watch: {
    $route() {
      this.initNavTheme()
    }
  },
  mounted() {
    this.scrollPositionListener = throttle(this.handelPositionScroll, 50)
    window.addEventListener('scroll', this.scrollPositionListener, true)
    this.initNavTheme()
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollPositionListener, true)
    window.removeEventListener('scroll', this.navThemeListener, true)
  },
  methods: {
    // 解决fixed元素超过浏览器被遮盖问题
    // 需监听scroll改变left值
    handelPositionScroll() {
      this.scrollLeft =
        document.body.scrollLeft || document.documentElement.scrollLeft
      this.scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop
    },
    // 是否是需要过渡效果的nav
    isTransformNav(routeName) {
      return transformNavPath.includes(routeName)
    },
    initNavTheme() {
      this.scrollPercent = 0
      if (this.isTransformNav(this.$route.name)) {
        this.theme = this.$route.name === 'brand' ? 'gold' : ''
        this.scrollPercent = 0
        this.fontColorVal = FONT_COLOR_MAX
        this.navThemeListener = throttle(this.handleNavScroll, 50)
        window.addEventListener('scroll', this.navThemeListener, true)
      } else {
        this.theme = 'white'
        this.scrollPercent = 100
        this.fontColorVal = FONT_COLOR_MIN
        if (this.navThemeListener) {
          window.removeEventListener('scroll', this.navThemeListener, true)
          this.navThemeListener = null
        }
      }
      this.navList.forEach(nav => {
        if (nav.children && nav.children.length > 0) {
          nav.active =
            !nav.link && nav.children.some(e => this.$route.path === e.link)
        } else {
          const routes = nav.activeRoutes || []
          this.$set(
            nav,
            'active',
            routes.some(item => this.$route.matched.some(e => e.path === item))
          )
        }
      })
    },
    handleNavScroll() {
      // 滚动高度
      const scrollHeight =
        document.body.scrollTop || document.documentElement.scrollTop
      // 是需要过渡效果的页面，且在过渡范围内
      let isTransformNav = this.isTransformNav(this.$route.name)
      if (isTransformNav && scrollHeight <= NAV_SCROLL_HEIGHT) {
        // 滚动百分比
        let percent =
          Math.round((scrollHeight / NAV_SCROLL_HEIGHT) * 10000) / 100.0
        if (percent >= 100) {
          percent = 100
          this.theme = 'white'
          this.fontColorVal = FONT_COLOR_MIN
          return
        } else {
          this.theme = this.$route.name === 'brand' ? 'gold' : ''
        }
        // 文字颜色变化范围
        let fontColorRange = parseInt(
          (scrollHeight / NAV_SCROLL_HEIGHT) * FONT_COLOR_RANGE
        )
        fontColorRange =
          fontColorRange >= FONT_COLOR_RANGE ? FONT_COLOR_RANGE : fontColorRange

        this.fontColorVal = FONT_COLOR_MAX - fontColorRange
        // 字体颜色
        this.scrollPercent = percent
      } else {
        this.theme = 'white'
        this.fontColorVal = FONT_COLOR_MIN
      }
    },
    doStat(item) {
      if (item.module) {
        this.$stat({
          key: 'nav_click',
          params: { module: item.module },
          pathName: this.$route.name
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common-header-component {
  width: 100%;
  height: 72px;
  border: 1px solid transparent;
  position: absolute;
  z-index: 999;
  &.sticky {
    position: fixed;
  }
  .content {
    height: 100%;
    width: 100%;
    position: relative;
    color: $white;
    .left {
      position: absolute;
      box-sizing: border-box;
      align-items: flex-start;
      width: 100%;
      .logo-box {
        margin-top: 18px;
        width: 110px;
        height: 36px;
        position: relative;
        .logo {
          position: absolute;
          top: 0;
          left: 0;
          width: 110px;
          height: 36px;
        }
      }

      .nav {
        margin-left: 32px;
        padding-top: 25px;
        align-items: flex-start;
        color: $white;
        & .item {
          padding: 0 20px;
          & > a {
            padding-bottom: 29px;
            position: relative;
            color: $white;
          }
          &:hover > a,
          & > a:hover,
          & > a.excat-nuxt-link-active,
          & > a.active {
            &:after {
              content: '';
              position: absolute;
              bottom: 2px;
              display: block;
              width: 24px;
              height: 4px;
              left: 50%;
              border-radius: 2px;
              background-color: $white;
              transform: translateX(-50%);
            }
          }
          i {
            display: inline-block;
            transform: rotate(180deg);
            transition: all 0.2s ease-in-out;
            font-size: 14px;
          }
          &.opened {
            a {
              i {
                transform: rotate(0deg);
              }
            }
          }
        }
        .menu-wrapper {
          position: absolute;
          left: 0;
          right: 0;
          top: 72px;
          background-color: #ffffff;
          display: none;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        }
        li {
          &:hover {
            .menu-wrapper {
              display: block;
            }
          }
        }
      }
    }
    .right {
      position: absolute;
      right: 150px;
      padding-top: 25px;
      align-items: flex-start;
      .label > .iconfont {
        margin-right: 4px;
      }
      .tel {
        margin-left: 16px;
        margin-top: -1px;
      }
    }
  }
  &.white {
    background: $white;
    border-bottom: 1px solid $neutral-color-3;
    .content {
      color: $text-color-desc;
      .left .nav {
        color: $text-color-desc;
        .item {
          & > a {
            color: $text-color-desc;
            &:hover,
            &.excat-nuxt-link-active,
            &.active {
              color: $primary-color !important;
              &:after {
                background-color: $primary-color !important;
              }
            }
          }
          &:hover {
            a {
              color: $primary-color !important;
              &:after {
                background-color: $primary-color !important;
              }
            }
          }
        }
      }
    }
  }
  &.gold {
    .content {
      color: $text-color-yellow;
      .left .nav .item {
        & > a {
          color: $sub-color-4;
          &:hover,
          &.excat-nuxt-link-active {
            color: $text-color-yellow;
            &:after {
              background-color: $text-color-yellow;
            }
          }
        }
        &:hover {
          a {
            color: $text-color-yellow;
            &:after {
              background-color: $text-color-yellow;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.common-header-component {
  .nav-menu {
    font-size: 13px;
    color: $text-color-default;
    min-height: 380px;
    box-shadow: inset 0 4px 10px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    //&:before {
    //  content: '';
    //  position: absolute;
    //  left: 0;
    //  right: 0;
    //  top: -10px;
    //  height: 10px;
    //  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    //}
    .nav-menu-inner {
      display: flex;
      justify-content: space-between;
      animation: menushow 0.2s;
    }
    .extra-wrapper {
      width: 404px;
      display: block;
      color: #727272;
      .poster {
        width: 396px;
        height: 198px;
        overflow: hidden;
        border-radius: 4px;
        border: 4px solid #ffffff;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          float: left;
        }
      }
      h4 {
        font-size: 13px;
        margin: 8px 0 0;
        font-weight: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: $text-color-default;
      }
    }
    .main-wrapper {
      flex: 1;
      overflow: hidden;
      .nav-group {
        width: 25%;
      }
      .submenu-list {
        li {
          margin-bottom: 13px;
          a {
            font-size: 13px;
            color: $text-color-default;
            display: inline-block;
            max-width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: relative;
            &[title] {
              padding-right: 44px;
              &:after {
                content: attr(title);
                position: absolute;
                right: 0;
                top: 3px;
                width: 40px;
                height: 15px;
                line-height: 15px;
                text-align: center;
                background-color: #f8653f;
                text-transform: uppercase;
                color: #ffffff;
                border-radius: 7.5px;
                font-size: 12px;
              }
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .nav-group {
      float: left;
      padding: 28px 0 0;
    }
    .group-header {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: $text-color-primary;
      padding: 0 0 9px 0;
      margin-right: 50px;
      border-bottom: 1px solid rgba(142, 144, 145, 0.25);
      i {
        margin-right: 4px;
      }
    }
    .group-body {
      padding: 10px 0;
    }
  }
  @keyframes menushow {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
